function AddressCellRender() {}

AddressCellRender.prototype.init = function (params) {
    var div = document.createElement('div');
    if (params.value !== "" || params.value !== undefined || params.value !== null) {
        var span1 = document.createElement('span');
        span1.style = "line-height: 20px;";
        span1.innerHTML = params.value.street1 + " " + params.value.street2 + ", " + params.value.city + " - " + params.value.stateProvince + " - " + params.value.country;
        div.appendChild(span1)
    }

    this.eGui = div;
};

AddressCellRender.prototype.getGui = function () {
    return this.eGui;
};

export default AddressCellRender;


// WEBPACK FOOTER //
// ./src/components/table/cellRenderers/AddressCellRender.js